import { pathRedirect } from '@/utils/auth'
import Dashboard from '@/containers/WechatBusinessHall/Dashboard'

export default {
  path: 'wechatBusinessHall',
  redirect: pathRedirect,
  children: [
    { path: 'dashboard', component: Dashboard }
  ],
  component: {
    template: '<router-view></router-view>'
  }
}



// WEBPACK FOOTER //
// ./src/router/wechatBusinessHall.js